const bundle = {
  close: () => 'Stäng',
  error: () => 'Fel',
  warn: () => 'Varning',
  info: () => 'Information',
  confirmation: () => 'Bekräftelse',
  progressIndeterminate: () => 'Pågår',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mellan ' + p['FROM_SECTION'] + ' och ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Hittade ingen matchande sektion.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Tryck på Enter för att välja värde.',
  indexer_touchInstructionText: () =>
    'Dubbeltryck och håll för att växla till gestläget och dra sedan uppåt eller nedåt för att justera värdet.',
  inputPassword_show: () => 'Visa lösenord',
  inputPassword_hide: () => 'Dölj lösenord',
  inputPassword_hidden: () => 'Lösenord dolt',
  formControl_clear: () => 'Rensa',
  formControl_loading: () => 'Laddar',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maxlängden ' + p['MAX_LENGTH'] + ' har överskridits.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tecken kvar.',
  select_noMatchesFound: () => 'Inga träffar.',
  select_oneMatchFound: () => 'En matchning har hittats',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Hittade ' + p['TOTAL_SIZE'] + ' matchningar',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Hittade ' + p['TOTAL_SIZE'] + ' eller fler matchningar',
  selectMultiple_showSelectedValues: () => 'Visa endast valda värden.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' värden valda.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Kryssruta markerad',
  selector_unselected: () => 'Kryssruta inte markerad',
  userAssistance_learnMore: () => 'Lär dig mer',
  userAssistance_required: () => 'Obligatorisk',
  filePicker_singleFileUploadError: () => 'Ladda upp en fil åt gången',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Du kan inte ladda upp filer av typen ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Du kan inte ladda upp filer av typen: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'okänd',
  filePicker_dropzonePrimaryText: () => 'Dra och släpp',
  filePicker_dropzoneSecondaryText: () => 'Välj en fil eller släpp en fil här',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Välj eller släpp filer här',
  filePicker_addFiles: () => 'Lägg till filer',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Öka',
  inputNumber_decrease: () => 'Minska',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Det finns inga objekt att visa',
  message_navigationFromMessagesRegion: () =>
    'Växlar till meddelanderegionen. Tryck på F6 för att navigera tillbaka till föregående element med fokus.',
  message_navigationToMessagesRegion: () =>
    'Meddelanderegionen har nya meddelanden. Tryck på F6 för att navigera till den senaste meddelanderegionen.',
  messageToast_allMessagesClosed: () => 'Alla toast-meddelanden är stängda.'
};
export default bundle;
